import { render } from "./AboutOnePage.vue?vue&type=template&id=33fe1077"
import script from "./AboutOnePage.vue?vue&type=script&lang=js"
export * from "./AboutOnePage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__